import { Controller } from "@hotwired/stimulus"

// One box ticks or unticks a list (17/10/2026, the schools a rule applies
// to); ticked by hand, the list ticks the box when all of it is ticked.
export default class extends Controller {
  static targets = ["all", "item"]

  connect() {
    this.sync()
  }

  toggle() {
    this.itemTargets.forEach((item) => { if (!item.disabled) item.checked = this.allTarget.checked })
  }

  sync() {
    const items = this.itemTargets.filter((item) => !item.disabled)
    this.allTarget.checked = items.length > 0 && items.every((item) => item.checked)
  }
}
